import { render, staticRenderFns } from "./WidgetSettingsHeaderForm.vue?vue&type=template&id=5bf0b71c"
import script from "./WidgetSettingsHeaderForm.vue?vue&type=script&lang=js"
export * from "./WidgetSettingsHeaderForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetSettingsHeaderForm.vue?vue&type=style&index=0&id=5bf0b71c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports